import { useMutation } from '@tanstack/react-query'

import { generateVariants } from '..'

const useGenerateVariantsMutation = () => {
  return useMutation(generateVariants)
}

export default useGenerateVariantsMutation
